import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext'
import {$wrapNodeInElement, mergeRegister} from '@lexical/utils'
import {
    $createParagraphNode,
    $insertNodes,
    $isRootOrShadowRoot,
    COMMAND_PRIORITY_EDITOR, COMMAND_PRIORITY_NORMAL,
    createCommand,
    LexicalCommand, PASTE_COMMAND,
} from 'lexical'
import {useContext, useEffect} from 'react'
import {$createAttachmentNode, AttachmentNode} from "./node/node"
import Attachment from "../../../../model2/attachment/attachment"
import AttachmentsCollection from "../../../../model2/attachment/attachments"
import {AttachmentsPluginContext} from "./context"

export type InsertAttachmentPayload = Readonly<Attachment>

export const INSERT_ATTACHMENT_COMMAND: LexicalCommand<InsertAttachmentPayload> = createCommand('INSERT_ATTACHMENT_COMMAND')

const debug = false
// const debug = "AttachmentsPlugin"

export default function AttachmentsPlugin({attachmentsCollection, onPasteImage}: {
    attachmentsCollection?  : AttachmentsCollection
    onPasteImage?           : callback
}): JSX.Element | null {
    const [editor]                  = useLexicalComposerContext()
    const attachmentsPluginContext  = useContext(AttachmentsPluginContext)

    useEffect(() => {
        if (!editor.hasNodes([AttachmentNode])) {
            throw new Error('AttachmentsPlugin: AttachmentNode not registered on editor');
        }

        attachmentsPluginContext.set(attachmentsCollection)

        return mergeRegister(
            editor.registerCommand<InsertAttachmentPayload>(
                INSERT_ATTACHMENT_COMMAND,
                (payload) => {
                    const attachmentNode = $createAttachmentNode({attachment: new Attachment(payload), width: attachmentsPluginContext.attachmentInMessageDefaultWidth})

                    debug && console.log(debug, 'INSERT_ATTACHMENT_COMMAND attachmentNode', attachmentNode, payload)

                    $insertNodes([attachmentNode])
                    if ($isRootOrShadowRoot(attachmentNode.getParentOrThrow())) {
                        $wrapNodeInElement(attachmentNode, $createParagraphNode).selectEnd()
                    }
                    return true
                },
                COMMAND_PRIORITY_EDITOR,
            ),
            editor.registerCommand(
                PASTE_COMMAND,
                (e: ClipboardEvent) => {
                    debug && console.log(debug, 'PASTE_COMMAND attachmentNode', e)

                    // We need to check if event.clipboardData is supported (Chrome & IE)
                    if (e.clipboardData && e.clipboardData.files) {
                        // Get the items from the clipboard
                        const files = e.clipboardData.files

                        debug && console.log(debug, 'PASTE_COMMAND attachmentNode files', files)

                        _.map(files, file=>{
                            debug && console.log(debug, 'PASTE_COMMAND attachmentNode file', file)

                            if (file.type.indexOf('image') !== -1) {
                                if (onPasteImage) onPasteImage(file)

                                // Prevent the image (or URL) from being pasted into the contenteditable element
                                e.preventDefault()
                            }
                        })
                    }

                    return false
                },
                COMMAND_PRIORITY_NORMAL,
            ),
        );
    }, [editor])

    return null
}
